import { createAction } from '@wix/communities-blog-client-common';

export const UPDATE_POSTS_RATINGS = 'post/UPDATE_POSTS_RATINGS';

export const updatePostsRatings = createAction(UPDATE_POSTS_RATINGS, (payload: any) => payload);
